var map = {
	"./80 x 50.jpg": "fc21",
	"./80 x 70.jpg": "a675",
	"./Conventional.jpg": "094e",
	"./Hesston 1.2 x 1.2.jpg": "360f",
	"./Midi Hesston 1.2 x 0.9.jpg": "f36d5",
	"./Mini Hesston 0.8 x 0.9.jpg": "b1f7",
	"./Quadrant 1.2 x 0.7.jpg": "1171"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8160";